import { post } from "@/utils/request";

//member
export const addUser = (params) => post("/api/user/addUser", params);
export const updateUser = (params) => post("/api/user/updateUser", params);
export const deleteMember = (params) => post("/api/user/deleteUser", params);
export const queryMember = (params) =>
  post("/api/user/selectWithCondition", params);
export const userSelectResGroupList = (params) =>
  post("/api/user/selectResGroupList", params);
export const userRelResGroup = (params) =>
  post("/api/user/relResGroup", params);
export const userDelResGroup = (params) =>
  post("/api/user/delResGroup", params);
export const queryMemberDetail = (params) =>
  post("/api/user/selectUserById", params);
export const listBindLoginPhone = (params) =>
  post("/api/user/listbindLoginPhone", params);

//organization
//新增部门机构
export const AddOrg = (params) => post("/api/organization/addOrg", params);
export const updateOrg = (params) =>
  post("/api/organization/updateOrg", params);
export const deleteOrg = (params) =>
  post("/api/organization/deleteOrg", params);
export const addPosition = (params) =>
  post("/api/position/addPosition", params);
export const updatePosition = (params) =>
  post("/api/position/updatePosition", params);
export const deletePosition = (params) =>
  post("/api/position/deletePosition", params);
export const positionSelectResGroupList = (params) =>
  post("/api/position/selectResGroupList", params);
export const getOrgTree = (params) =>
  post("/api/organization/getOrgTree", params);
export const positionRelResGroup = (params) =>
  post("/api/position/relResGroup", params);
export const positionDelResGroup = (params) =>
  post("/api/position/delResGroup", params);

//Res
export const addResource = (params) =>
  post("/api/resource/addResource", params);
export const updateResource = (params) =>
  post("/api/resource/updateResource", params);
export const deleteResource = (params) =>
  post("/api/resource/deleteResource", params);
export const getResourceTree = (params) =>
  post("/api/resource/getResourceTree", params);

//ResGroup
export const addResGroup = (params) =>
  post("/api/resGroup/addResGroup", params);
export const updateResGroup = (params) =>
  post("/api/resGroup/updateResGroup", params);
export const deleteResGroup = (params) =>
  post("/api/resGroup/deleteResGroup", params);
export const queryResGroupList = (params) =>
  post("/api/resGroup/selectResGroupList", params);
export const relateResGroup = (params) =>
  post("/api/resGroup/relResource", params);
